import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=c318d9ac&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=js&"
export * from "./UserTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=c318d9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318d9ac",
  null
  
)

export default component.exports